import 'twin.macro';

import iconJoystick from '../../assets/svgs/joystick_white.svg';

const LightTowerSection = (props: { handleClick: () => void }) => {
  return (
    <div tw="pt-[188.718%] md:pt-[51.11%] relative w-full flex flex-col bg-lighttower-mobile md:bg-lighttower-desktop bg-no-repeat bg-center bg-cover">
      <div tw="pt-[18vw] md:pt-[4vw] absolute left-0 top-0 w-full h-full">
        <div
          css={{
            backgroundImage:
              'linear-gradient(180deg, #FFFFFF 32.41%, #A98FBC 100%)',
          }}
          tw="pb-[0.5vw] font-lumadFree text-[3.8vw] md:text-[1.8vw] text-center leading-[140%] tracking-normal bg-clip-text text-transparent"
        >
          ROUND 1
        </div>
        <div tw="mx-auto mt-[-0.8vw] max-w-[84vw] md:max-w-[46vw] font-normal font-lumadFree text-[5.4vw] md:text-[3.2vw] text-center leading-[130%] tracking-normal">
          Saturday, November 12th
        </div>
        <div tw="mx-auto pt-[5vw] md:pt-[2.4vw] pb-[85vw] md:pb-[17vw] max-w-[48vw] md:max-w-[21.06vw] text-center text-[3.8vw] md:text-[1.6vw] leading-[130%]">
          Win Big &amp; Take Your Place in Web3 History
        </div>
        <button
          tw="block mx-auto relative w-[58.5vw] md:w-[20vw] h-[14vw] md:h-[4.8vw] hover:opacity-75 transition-all duration-300"
          onClick={props.handleClick}
        >
          <div tw="absolute left-0 top-0 w-full h-full bg-[#D2193A] -skew-x-12 z-10" />
          <div tw="absolute left-0 top-0 w-full h-full flex justify-center items-center text-center gap-[4vw] md:gap-[1vw] z-20">
            <span tw="text-[4vw] md:text-[1.4vw] text-white">ENTER NOW</span>
            <img alt="joystick" src={iconJoystick} tw="w-[4vw] md:w-[1.6vw]" />
          </div>
        </button>
        <div tw="mx-auto px-4 pt-[11vw] md:pt-[2.8vw] max-w-[55vw] md:max-w-none text-[3.8vw] md:text-[1.85vw] text-center leading-[130%]">
          This is why they'll remember your name…
        </div>
      </div>
    </div>
  );
};

export default LightTowerSection;
